/**
 * This service is to get the list of columns for the list view widget
 */
angular.module(NgAppName).service('ListviewService', [function() {
	this.columns = {
		unit: {
			type: 'unit',
			title: 'Residence',
			class: 'residence'
		},
		unitSortable: {
			type: 'unit',
			title: 'Apt.',
			sortable: true,
			dataSort: 'unit',
			class: 'unit'
		},
		unitLinkSortable: {
			type: 'unitLink',
			title: 'Unit#',
			sortable: true,
			dataSort: 'unit',
			class: 'unit'
		},
		myListingUnit: {
			type: 'myListingUnit',
			title: 'Apartment',
			sortable: true,
			dataSort: 'unit',
			class: 'unit'
		},
		property: {
			type: 'property',
			title: 'Property',
			sortable: false,
			dataSort: 'unit',
			class: 'address'
		},
		addressUnit: {
			type: 'addressUnit',
			title: 'Address',
			class: 'address'
		},
		addressUnitSortable: {
			type: 'addressUnitSortable',
			title: 'Address',
			sortable: true,
			dataSort: 'unit',
			class: 'address'
		},
		buildingAddress: {
			type: 'buildingAddress',
			title: 'Building name / Address',
			class: 'address'
		},
		buildingAddressSortable: {
			type: 'buildingAddressSortable',
			title: 'Building name / Address',
			sortable: true,
			dataSort: 'address',
			class: 'address',
			id: 'display_name'
		},
		typeAndHood: {
			type: 'typeAndHood',
			title: 'Type / Neighborhood',
			class: 'type-hood'
		},
		neighborhood: {
			type: 'neighborhood',
			title: 'Neighborhood',
			class: 'hood'
		},
		neighborhoodSortable: {
			type: 'neighborhoodSortable',
			title: 'Neighborhood',
			sortable: true,
			dataSort: 'hood',
			class: 'hood',
			id: 'hood'
		},
		type: {
			type: 'type',
			title: 'Type',
			class: 'type'
		},
		buildingTypeSortable: {
			type: 'typeSortable',
			title: 'Type',
			sortable: true,
			dataSort: 'building_type',
			class: 'type'
		},
		typeSortable: {
			type: 'typeSortable',
			title: 'Type',
			sortable: true,
			dataSort: 'type',
			class: 'type'
		},
		beds: {
			type: 'beds',
			title: 'Beds',
			class: 'beds'
		},
		bedsSortable: {
			type: 'bedsSortable',
			title: 'Beds',
			sortable: true,
			dataSort: 'beds',
			class: 'beds',
			id: 'bedroom_id'
		},
		bedrooms: {
			type: 'bedrooms',
			title: 'Bedrooms',
			class: 'beds'
		},
		bedroomsSortable: {
			type: 'bedroomsSortable',
			title: 'Bedrooms',
			sortable: true,
			dataSort: 'beds',
			class: 'beds'
		},
		baths: {
			type: 'baths',
			title: 'Baths',
			class: 'baths'
		},
		bathsSortable: {
			type: 'bathsSortable',
			title: 'Baths',
			sortable: true,
			dataSort: 'baths',
			class: 'baths',
			id: 'bathrooms'
		},
		bathrooms: {
			type: 'bathrooms',
			title: 'Bathrooms',
			class: 'baths'
		},
		bathroomsSortable: {
			type: 'bathroomsSortable',
			title: 'Bathrooms',
			sortable: true,
			dataSort: 'baths',
			class: 'baths'
		},
		size: {
			type: 'size',
			title: 'size',
			class: 'size'
		},
		sizeSortable: {
			type: 'sizeSortable',
			title: 'Size',
			sortable: true,
			dataSort: 'sqft',
			class: 'size',
			id: 'sqft_raw'
		},
		myListingSize: {
			type: 'myListingSize',
			title: 'Size',
			class: 'size'
		},
		bedsbathssize: {
			type: 'bedsbathssize',
			title: 'Beds / Baths / Size',
			class: 'beds-baths-size'
		},
		bedssize: {
			type: 'bedssize',
			title: 'Beds / Size',
			class: 'beds-size'
		},
		price: {
			type: 'price',
			title: 'Price',
			class: 'price'
		},
		priceSortable: {
			type: 'priceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'price',
			class: 'price'
		},
		salePriceSortable: {
			type: 'salePriceSortable',
			title: 'Price',
			sortable: true,
			// dataSortObject: 'sale',
			id: 'recent_price_raw',
			dataSort: 'recent_price_raw',
			class: 'price'
		},
		rentalPriceSortable: {
			type: 'rentalPriceSortable',
			title: 'Price',
			sortable: true,
			id: 'recent_rent_price_raw',
			dataSort: 'recent_rent_price_raw',
			class: 'price'
		},
		myListingPriceSortable: {
			type: 'myListingPriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'price',
			class: 'price'
		},
		pricePerSqft: {
			type: 'pricePerSqft',
			title: 'Price/Ft<sup>2</sup>',
			class: 'price-ft'
		},
		pricePerSqftSortable: {
			type: 'pricePerSqftSortable',
			title: 'Price/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'ppsqft',
			class: 'price-ft',
			id: 'ppsqft_raw'
		},
		salePricePerSqftSortable: {
			type: 'salePricePerSqftSortable',
			title: 'Price/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_ppsqft_raw',
			class: 'price-ft',
			id: 'recent_ppsqft_raw'
		},
		rentalPricePerSqftSortable: {
			type: 'rentalPricePerSqftSortable',
			title: 'Price/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_rent_ppsqft_raw',
			class: 'price-ft',
			id: 'recent_rent_ppsqft_raw'
		},
		
		priceChangeDate: {
			type: 'priceChangeDate',
			title: 'Date',
			class: 'price-change-date'
		},
		dateListed: {
			type: 'dateListed',
			title: 'Listed',
			class: 'date'
		},
		dateListedSortable: {
			type: 'dateListedSortable',
			title: 'Listed',
			sortable: true,
			dataSort: 'new',
			class: 'date',
			id: 'listed_date_timestamp'
		},
		saleDate: {
			type: 'saleDate',
			title: 'Sale date',
			class: 'date'
		},
		saleDateSortable: {
			type: 'saleDateSortable',
			title: 'Sale date',
			sortable: true,
			dataSort: 'sale_date_timestamp',
			class: 'date'
		},
		saleDateShortSortable: {
			type: 'saleDateShortSortable',
			title: 'Date',
			sortable: true,
			dataSort: 'sale_date_timestamp',
			class: 'date'
		},
		rating: {
			type: 'rating',
			title: 'Rating',
			class: 'rating'
		},
		ratingSortable: {
			type: 'ratingSortable',
			title: 'Rating',
			sortable: true,
			dataSort: 'rating',
			class: 'rating'
		},
		doorman: {
			type: 'doorman',
			title: 'Doorman',
			class: 'doorman'
		},
		doormanSortable: {
			type: 'doormanSortable',
			title: 'Doorman',
			sortable: true,
			dataSort: 'doorman',
			class: 'doorman'
		},
		available: {
			type: 'available',
			title: 'Available',
			class: 'available'
		},
		availableSortable: {
			type: 'availableSortable',
			title: 'Apartments<br>Available',
			sortable: true,
			dataSort: 'available',
			class: 'available',
			id: 'totalListings'
		},

		pricePerSqftClosed: {
			type: 'pricePerSqftClosed',
			title: 'Price/Ft<sup>2</sup> Closed',
			class: 'pricePerSqftClosed'
		},

		pricePerSqftClosedSortable: {
			type: 'pricePerSqftClosedSortable',
			title: 'Price/Ft<sup>2</sup> Closed',
			sortable: true,
			dataSort: 'pricePerSqftClosed',
			class: 'pricePerSqftClosed',
			id: 'pricePerSqftClosed'

		},
		pricePerSqftAvailableSortable: {
			type: 'pricePerSqftAvailableSortable',
			title: 'Price/Ft<sup>2</sup> Available',
			sortable: true,
			dataSort: 'pricePerSqftAvailable',
			class: 'pricePerSqftAvailable',
			id: 'pricePerSqftAvailable'
		},

		priceRange: {
			type: 'priceRange',
			title: 'Price Range',
			class: 'priceRange',
		},

		priceRangeSortable: {
			type: 'priceRangeSortable',
			title: 'Price Range',
			sortable: true,
			dataSort: 'priceRangeSortable',
			class: 'priceRangeSortable',
			id: 'priceRangeSortable'
		},

		residence: {
			type: 'residence',
			title: 'Residence',
			class: 'residence'
		},
		residenceSortable: {
			type: 'residenceSortable',
			title: 'Residence',
			sortable: true,
			dataSort: 'unit',
			class: 'residence'
		},
		sqft: {
			type: 'sqft',
			title: 'Approx ft<sup>2</sup>',
			class: 'sqft'
		},
		sqftSortable: {
			type: 'sqftSortable',
			title: 'Approx ft<sup>2</sup>',
			sortable: true,
			dataSort: 'sqft',
			class: 'sqft'
		},
		monthlyCharge: {
			type: 'monthlyCharge',
			title: 'Est. Monthly C.C.',
			class: 'monthly-cc'
		},
		monthlyChargeSortable: {
			type: 'monthlyChargeSortable',
			title: 'Est. Monthly C.C.',
			sortable: true,
			dataSort: 'maintenance',
			class: 'monthly-cc'
		},
		monthlyChargeSortable2: {
			type: 'monthlyChargeSortable2',
			title: 'Common Charges',
			sortable: true,
			dataSort: 'common_raw',
			id: 'common_raw',
			class: 'monthly-cc'
		},
		maintenanceSortable: {
			type: 'maintenanceSortable',
			title: 'Maintenance',
			sortable: true,
			dataSort: 'maintenance_raw',
			id: 'maintenance_raw',
			class: 'monthly-cc'
		},
		monthlyTaxes: {
			type: 'monthlyCharge',
			title: 'Est. Monthly R.E Taxes',
			class: 'monthly-tax'
		},
		monthlyTaxesSortable: {
			type: 'monthlyChargeSortable',
			title: 'Est. Monthly R.E Taxes',
			sortable: true,
			dataSort: 'tax',
			class: 'monthly-tax'
		},
		monthlyTaxesSortable2: {
			type: 'monthlyTaxesSortable2',
			title: 'R.E Taxes',
			sortable: true,
			dataSort: 'tax_raw',
			id: 'tax_raw',
			class: 'monthly-tax'
		},
		lock: {
			type: 'lock',
			title: '&nbsp;',
			class: 'lock'
		},
		expand: {
			type: 'expand',
			title: '&nbsp;',
			class: 'expand'
		},
		linksWrapper: {
			type: 'linksWrapper',
			title: '',
			class: 'links-wrapper'
		},
		saveMessageWrapper: {
			type: 'saveMessageWrapper',
			title: '',
			class: 'save-message-wrapper'
		},
		extraInfo: {
			type: 'extraInfo',
			title: '',
			class: 'extra-info'
		},
		agentName: {
			type: 'agentName',
			title: '',
			class: 'agent-name'
		},
		// agentInfo: {
		// 	type: 'agentInfo',
		// 	title: '',
		// 	class: 'agent-info'
		// },
		agentPhone: {
			type: 'agentPhone',
			title: '',
			class: 'agent-phone',
			id: 'phone'
		},
		agentEmail: {
			type: 'agentEmail',
			title: '',
			class: 'agent-email',
			id: 'email'
		},
		agentFirm: {
			type: 'agentFirm',
			title: '',
			class: 'agent-firm',
			id: 'firm'
		},
		buttons: {
			type: 'buttons',
			title: '',
			class: 'buttons'
		},
		daysOnMarket: {
			type: 'daysOnMarket',
			title: 'Days On Market',
			sortable: true,
			dataSort: 'days_on_market',
			class: 'days-on-market'
		},
		createdBy: {
			type: 'createdBy',
			title: 'Created By',
			sortable: true,
			dataSort: 'created_by',
			class: 'created-by'
		},
		listedOn: {
			type: 'listedOn',
			title: 'Listed On',
			sortable: true,
			dataSort: 'new',
			class: 'listed-on'
		},
		listedUntil: {
			type: 'listedUntil',
			title: 'Listed Until',
			sortable: true,
			dataSort: 'listed_until',
			class: 'listed-until'
		},

		freeRent: {
			type: 'freeRent',
			title: 'Free Rent',
			class: 'free-rent'
		},

		status: {
			type: 'status',
			title: 'Status',
			sortable: true,
			dataSort: 'status',
			class: 'status'
		},

		alert: {
			type: 'alert',
			title: '<i class="fa fa-bell" aria-hidden="true"></i>',
			class: 'alert'
		},

		alertOnExpiry: {
			type: 'alert',
			title: 'Alert On Expiry',
			class: 'alert'
		},

		rentedOn: {
			type: 'rentedOn',
			title: 'Rented On',
			sortable: true,
			dataSort: 'new',
			class: 'rented-on'
		},
		rentedUntil: {
			type: 'rentedUntil',
			title: 'Rented Until',
			sortable: true,
			dataSort: 'rented_until',
			class: 'rented-until'
		},

		publish: {
			type: 'publish',
			title: '',
			class: 'publish'
		},

		addToCr: {
			type: 'addToCr',
			title: 'Add To CityRealty',
			class: 'add-to-cr'
		},

		priceChange: {
			type: 'priceChange',
			title: 'Price Change',
			class: 'price-change'
		},

		priceChangeDescription: {
			type: 'priceChangeDescription',
			title: '',
			class: 'price-change-description'
		},

		buildingSortable: {
			type: 'building',
			title: 'Building',
			sortable: true,
			dataSort: 'name',
			class: 'building'
		},

		activeListingsSortable: {
			type: 'activeListings',
			title: 'Active Listings',
			sortable: true,
			dataSort: 'listed',
			class: 'active-listings'
		},

		unpublishedListingsSortable: {
			type: 'unpublishedListings',
			title: 'Unpublished Listings',
			sortable: true,
			dataSort: 'not_listed',
			class: 'unpublished-listings'
		},

		rentedListingsSortable: {
			type: 'rentedListings',
			title: 'Rented Listings',
			sortable: true,
			dataSort: 'rented',
			class: 'rented-listings'
		},

		lastUpdatedSortable: {
			type: 'lastUpdated',
			title: 'Last Updated',
			sortable: true,
			dataSort: 'last_update',
			class: 'last-updated'
		},

		manageListings: {
			type: 'manageListings',
			title: '',
			class: 'managed-listings'
		},

		link: {
			type: 'link',
			title: '',
			class: 'link'
		},

		closingPriceSortable: {
			type: 'closingPriceSortable',
			title: 'Closing Price',
			sortable: true,
			dataSort: 'sale_price',
			class: 'price',
			id: 'sale_price_raw'
		},

		askingPriceSortable: {
			type: 'askingPriceSortable',
			title: 'Asking Price',
			sortable: true,
			dataSort: 'asking_price',
			class: 'price',
			id: 'asking_price_raw'
		},

		closingDateSortable: {
			type: 'closingDateSortable',
			title: 'Closing Date',
			sortable: true,
			dataSort: 'sale_date',
			class: 'date',
			id: 'sale_date_raw'
		},

		buildingName: {
			type: 'buildingName',
			title: 'Address',
			class: 'address'
		},

		buildingNameSortable: {
			type: 'buildingNameSortable',
			title: 'Address',
			sortable: true,
			dataSort: 'name',
			id: 'building_name',
			class: 'address'
		},

		avgPriceSqftSortable: {
			type: 'avgPriceSqftSortable',
			title: 'Avg. <br>Price/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'avg_ppsqft',
			id: 'avg_price_sqft'
		},
		totalClosingsSortable: {
			type: 'totalClosingsSortable',
			title: 'Total <br>Closings',
			sortable: true,
			dataSort: 'total_closings',
			id: 'total_closings'
		},
		totalClosings90Sortable: {
			type: 'totalClosings90Sortable',
			title: 'Sales <br>past 90d',
			sortable: true,
			dataSort: 'total_closings_90',
			id: 'total_closings_90_days'
		},
		closingRangeSortable: {
			type: 'closingRangeSortable',
			title: 'Price Range',
			sortable: true,
			dataSort: 'price_range',
			id: 'closing_range'
		},
		totalSalesSortable: {
			type: 'totalSalesSortable',
			title: 'Total Sales',
			sortable: true,
			dataSort: 'total_sales'
		},
		closingPercentSortable: {
			type: 'closingPercentSortable',
			title: '% Closed',
			sortable: true,
			dataSort: 'closing_percent' // correct this value
		},
		totalChargesSqftSortable: {
			type: 'totalChargesSqftSortable',
			title: 'Total / Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'maintenanceSqFT_raw',
			id: 'maintenanceSqFT_raw'
		},

		mRBUnitSortable: {
			type: 'mRBUnitSortable',
			title: 'Unit#',
			sortable: true,
			dataSort: 'unit',
			class: 'm-rb-unit'
		},
		mRBBedsSortable: {
			type: 'mRBBedsSortable',
			title: 'Beds',
			sortable: true,
			dataSort: 'beds',
			class: 'm-rb-beds'
		},
		mRBSizeSortable: {
			type: 'mRBSizeSortable',
			title: 'Size',
			sortable: true,
			dataSort: 'sqft',
			class: 'm-rb-size'
		},
		mRBPriceSortable: {
			type: 'mRBPriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'recent_rent_price_raw',
			class: 'm-rb-price'
		},
		mRBPricePerSqftSortable: {
			type: 'mRBPricePerSqftSortable',
			title: 'Price<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_rent_ppsqft_raw',
			class: 'm-rb-price-per-sqft'
		},
		mCoopBUnitSortable: {
			type: 'mCoopBUnitSortable',
			title: 'Unit#',
			sortable: true,
			dataSort: 'unit',
			class: 'm-coopb-unit'
		},
		mCoopBSalePriceSortable: {
			type: 'mCoopBSalePriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'recent_price_raw',
			class: 'm-coopb-price'
		},
		mCoopBRentalPriceSortable: {
			type: 'mCoopBRentalPriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'recent_rent_price_raw',
			class: 'm-coopb-price'
		},
		mCoopBSalePricePerSqftSortable: {
			type: 'mCoopBSalePricePerSqftSortable',
			title: 'Price<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_ppsqft_raw',
			class: 'm-coopb-price-per-sqft'
		},
		mCoopBRentalPricePerSqftSortable: {
			type: 'mCoopBRentalPricePerSqftSortable',
			title: 'Price<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_rent_ppsqft_raw',
			class: 'm-coopb-price-per-sqft',
		},
		mCoopBMaintenanceSortable: {
			type: 'mCoopBMaintenanceSortable',
			title: 'Maintenance',
			sortable: true,
			dataSort: 'maintenance_raw',
			class: 'm-coopb-maintenance'
		},
		mCoopBTotalChargesSqftSortable: {
			type: 'mCoopBTotalChargesSqftSortable',
			title: 'Total<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'maintenanceSqFT_raw',
			class: 'm-coopb-totalcharges-sqft'
		},
		mCondoBUnitSortable: {
			type: 'mCondoBUnitSortable',
			title: 'Unit#',
			sortable: true,
			dataSort: 'unit',
			class: 'm-condob-unit'
		},
		mCondoBSalePriceSortable: {
			type: 'mCondoBSalePriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'recent_price_raw',
			class: 'm-condob-price'
		},
		mCondoBRentalPriceSortable: {
			type: 'mCondoBRentalPriceSortable',
			title: 'Price',
			sortable: true,
			dataSort: 'recent_rent_price_raw',
			class: 'm-condob-price'
		},
		mCondoBSalePricePerSqftSortable: {
			type: 'mCondoBSalePricePerSqftSortable',
			title: 'Price<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_ppsqft_raw',
			class: 'm-condob-price-per-sqft'
		},
		mCondoBRentalPricePerSqftSortable: {
			type: 'mCondoBRentalPricePerSqftSortable',
			title: 'Price<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'recent_rent_ppsqft_raw',
			class: 'm-condob-price-per-sqft',
		},
		mCondoBMonthlyChargeSortable2: {
			type: 'mCondoBMonthlyChargeSortable2',
			title: 'Common<br/>Charges',
			sortable: true,
			dataSort: 'common_raw',
			class: 'm-condob-monthly-charges'
		},
		mCondoBMonthlyTaxesSortable2: {
			type: 'mCondoBMonthlyTaxesSortable2',
			title: 'R.E<br/>Taxes',
			sortable: true,
			dataSort: 'tax_raw',
			class: 'm-condob-monthly-taxes'
		},
		mCondoBTotalChargesSqftSortable: {
			type: 'mCondoBTotalChargesSqftSortable',
			title: 'Total<br/>/Ft<sup>2</sup>',
			sortable: true,
			dataSort: 'maintenanceSqFT_raw',
			class: 'm-condob-totalcharges-sqft'
		}
	};

	this.columnsCombinations = {
		buildings: ['ratingSortable', 'buildingAddressSortable', 'neighborhoodSortable', 'typeSortable', 'doormanSortable', 'availableSortable', 'linksWrapper', 'saveMessageWrapper'],
		buildingsIndices: ['expand', 'buildingAddressSortable', 'pricePerSqftClosedSortable', 'pricePerSqftAvailableSortable', 'availableSortable', 'priceRange', 'extraInfo'],
		buildingsIndicesDetails: ['expand', 'buildingName', 'typeAndHood', 'priceRange', 'pricePerSqftClosed', 'available', 'rating'],
		listings: ['lock', 'expand', 'addressUnit', 'typeAndHood', 'bedssize', 'price', 'pricePerSqft', 'dateListed', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		// availabilities: ['expand', 'unit', 'beds', 'baths', 'size', 'pricePerSqft', 'dateListed', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		availabilities: ['expand', 'unit', 'bedsSortable', 'bathsSortable', 'sizeSortable', 'priceSortable', 'pricePerSqftSortable', 'dateListedSortable', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		neighborhoodListings: ['expand', 'addressUnit', 'type', 'bedssize', 'price', 'pricePerSqft', 'dateListed', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		ownersListings: ['expand', 'addressUnit', 'neighborhoodSortable', 'bedssize', 'priceSortable', 'pricePerSqftSortable', 'dateListedSortable', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		searchClosedSales: ['expand', 'addressUnit', 'type', 'neighborhood', 'bedssize', 'price', 'pricePerSqft', 'saleDateSortable', 'linksWrapper', 'extraInfo'],
		buildingAppartments: ['expand', 'residenceSortable', 'bedsSortable', 'bathsSortable', 'sizeSortable', 'priceSortable', 'pricePerSqftSortable', 'dateListedSortable', 'linksWrapper', 'saveMessageWrapper', 'extraInfo'],
		recentSales: ['expand', 'addressUnit', 'neighborhoodSortable', 'bedsSortable', 'sizeSortable', 'pricePerSqftSortable', 'priceSortable', 'saleDateShortSortable', 'extraInfo'],
		premiumBuildingListings: ['residenceSortable', 'sqftSortable', 'bedroomsSortable', 'bathroomsSortable', 'priceSortable', 'monthlyChargeSortable', 'monthlyTaxesSortable', 'linksWrapper'],
		myAgents: ['agentName', 'agentPhone', 'agentEmail', 'agentFirm', 'buttons'],
		myListingsAvailAptsManager: ['link', 'myListingUnit', 'myListingSize', 'priceSortable', 'freeRent', 'listedOn', 'listedUntil', 'daysOnMarket', 'createdBy', 'status'],
		myListingsAddRentedAptsManager: ['myListingUnit', 'beds', 'baths', 'size', 'freeRent', 'rentedOn', 'rentedUntil', 'alert', 'publish'],
		myListingsAvailAptsManagerAll: ['link', 'property', 'myListingSize', 'priceSortable', 'freeRent', 'listedOn', 'listedUntil', 'daysOnMarket', 'createdBy', 'status'],
		myListingsAddRentedAptsManagerAll: ['property', 'beds', 'baths', 'size', 'freeRent', 'rentedOn', 'rentedUntil', 'alert', 'publish'],
		myListingsAvailAptsBroker: ['link', 'property', 'myListingSize', 'priceSortable', 'freeRent', 'listedOn', 'listedUntil', 'daysOnMarket', 'createdBy', 'status'],
		myListingsAvailApts: ['link', 'property', 'myListingSize', 'priceSortable', 'listedOn', 'listedUntil', 'daysOnMarket', 'status'],
		myListingsAddRentedApts: ['property', 'myListingSize', 'rentedOn', 'rentedUntil', 'alertOnExpiry', 'addToCr'],
		myListingsBuildingList: ['buildingSortable', 'activeListingsSortable', 'unpublishedListingsSortable', 'rentedListingsSortable', 'lastUpdatedSortable', 'manageListings'],
		priceHistory: ['priceChangeDate', 'priceChange', 'priceChangeDescription'],
		recentClosings: ['expand', 'residenceSortable', 'bedsSortable', 'bathsSortable', 'sizeSortable', 'closingPriceSortable', 'pricePerSqftSortable', 'askingPriceSortable', 'closingDateSortable', 'extraInfo'],
		recentClosingsIndices: ['expand', 'addressUnit', 'neighborhoodSortable', 'bedsSortable', 'sizeSortable', 'closingPriceSortable', 'pricePerSqftSortable', 'closingDateSortable', 'extraInfo'],
		condoClosings: ['expand', 'addressUnitSortable', 'neighborhoodSortable', 'bedsSortable', 'sizeSortable', 'priceSortable', 'pricePerSqftSortable', 'closingDateSortable', 'extraInfo'],
		closingsByBuilding: ['expand', 'buildingNameSortable', 'avgPriceSqftSortable', 'totalClosingsSortable', 'totalClosings90Sortable', 'closingRangeSortable', 'totalSalesSortable', 'buildingTypeSortable', 'extraInfo'],
		devClosingsByBuilding: ['expand', 'buildingNameSortable', 'avgPriceSqftSortable', 'totalClosingsSortable', 'totalClosings90Sortable', 'closingRangeSortable', 'totalSalesSortable', 'closingPercentSortable', 'extraInfo'],
		buildingUnits: ['unitLinkSortable', 'bedsSortable', 'sizeSortable', 'salePriceSortable', 'salePricePerSqftSortable', 'rentalPriceSortable', 'rentalPricePerSqftSortable', 'monthlyChargeSortable2', 'monthlyTaxesSortable2', 'totalChargesSqftSortable' ],
		buildingUnitsCoop: ['unitLinkSortable', 'bedsSortable', 'sizeSortable', 'salePriceSortable', 'salePricePerSqftSortable', 'rentalPriceSortable', 'rentalPricePerSqftSortable', 'maintenanceSortable',  'totalChargesSqftSortable'],
		mBuildingUnitsNoFeeRentals: ['mRBUnitSortable', 'mRBBedsSortable', 'mRBSizeSortable', 'mRBPriceSortable', 'mRBPricePerSqftSortable'],
		mBuildingUnitsCoopSales: ['mCoopBUnitSortable', 'mCoopBSalePriceSortable', 'mCoopBSalePricePerSqftSortable', 'mCoopBMaintenanceSortable', 'mCoopBTotalChargesSqftSortable'],
		mBuildingUnitsCoopRentals: ['mCoopBUnitSortable', 'mCoopBRentalPriceSortable', 'mCoopBRentalPricePerSqftSortable', 'mCoopBMaintenanceSortable', 'mCoopBTotalChargesSqftSortable'],
		mBuildingUnitsCondoSales: ['mCondoBUnitSortable', 'mCondoBSalePriceSortable', 'mCondoBSalePricePerSqftSortable', 'mCondoBMonthlyChargeSortable2', 'mCondoBMonthlyTaxesSortable2', 'mCondoBTotalChargesSqftSortable'],
		mBuildingUnitsCondoRentals: ['mCondoBUnitSortable', 'mCondoBRentalPriceSortable', 'mCondoBRentalPricePerSqftSortable', 'mCondoBMonthlyChargeSortable2', 'mCondoBMonthlyTaxesSortable2', 'mCondoBTotalChargesSqftSortable']
	};

	this.getColumns = function(combinationKey) {
		var self = this;
		var columns = {};

		if (!combinationKey || !this.columnsCombinations[combinationKey]) {
			return null;
		}

		angular.forEach(this.columnsCombinations[combinationKey], function(value, key) {
			columns[value] = self.columns[value];
		});

		return columns;
	};
}]);
